import axios from 'src/utils/axios'
import { API_BASE_URL } from 'src/constants'

export const fetchDiseases = async (params) => {
  try {
    // If params is a URLSearchParams object, convert it to a plain object
    const queryParams = params instanceof URLSearchParams ? Object.fromEntries(params.entries()) : params

    const response = await axios.get(`${API_BASE_URL}/omim-diseases/`, {
      params: {
        ...queryParams,
        limit: 100,
      },
    })
    return response.data.results
  } catch (error) {
    console.error('Error fetching diseases:', error)
    return []
  }
}
